<section class="appendix-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="appendix-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [span]="2" [control]="form.controls['title']"></astral-input>
          <astral-select [control]="form.controls['appendixType']" [itemsSource]="appendixTypes"></astral-select>
          <astral-select [control]="form.controls['sortOrder']" [itemsSource]="orderSelection"></astral-select>
        </astral-layout-group>

        <div class="astral-form-stack astral-form-stack--relaxed">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
            <astral-toggle [control]="form.controls['useForDwelling']"></astral-toggle>
            <astral-toggle [control]="form.controls['useForParking']"></astral-toggle>
            <astral-toggle [control]="form.controls['companyLogo']"></astral-toggle>
            <astral-toggle [control]="form.controls['realEstateLevelUsage']"></astral-toggle>
          </astral-layout-group>

          <astral-input [control]="form.controls['pageFooter']"></astral-input>
        </div>
      </section>

      @if (isSelfDefined) {
        <section class="appendix-form__sections astral-section-surface astral-stack-m">
          <h4>{{ 'APPENDIX.SECTIONS' | translate }}</h4>

          @for (tSection of $any(sections.controls); track tSection; let i = $index) {
            <section class="appendix-form__section-card astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [span]="3" [control]="tSection.controls['header']"></astral-input>
                <astral-select [control]="tSection.controls['sortOrder']" [itemsSource]="orderSelection"></astral-select>
              </astral-layout-group>

              <astral-textarea [control]="tSection.controls['content']" [rows]="6"></astral-textarea>

              @if (showDeleteSection) {
                <div>
                  <astral-button
                    variant="secondary"
                    size="small"
                    type="button"
                    icon="trash"
                    labelKey="DELETE_BTN"
                    (click)="removeSection(i)"
                  ></astral-button>
                </div>
              }
            </section>
          }

          <div>
            <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_BTN" (click)="addSection()"></astral-button>
          </div>
        </section>
      }
    </form>
  }
</section>
